import React, { useRef, useState } from "react";
import {
  Button,
  InputAdornment,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  FormControlLabel,
  Switch,
} from "@mui/material";

import UploadFileIcon from "@mui/icons-material/UploadFile";
import BadgeIcon from "@mui/icons-material/Badge";
import LinkIcon from "@mui/icons-material/Link";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import Slide from "@mui/material/Slide";
import { styled } from "@mui/material/styles";
import AnswerQuestion from "./AnswerQuestion";
import ViewQuestion from "./ViewQuestion";
import ViewExam from "./ViewExam";
import MathRendererContent from "../../common/MathRendererContent";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ExamForm({
  formQuestionData,
  errors,
  handleChangeInputQuestion,
  listKeys,
  question,
  handleChangeSelectQuestions,
  refs,
  handleChangeUploadFileQuestions,
  handleChangeContentQuestions,
  handleChangeInputAnswer,
  setOpenDialogQuestion,
  upLoadImageQuestions,
  openDialogQuestion,
  handleChangeDateStartTime,
  handleChangeDateEndTime,
  handleFileUpload,
  handleInsertExam,
  setOpenDialogExam,
  openDialogExam,
  questionsData,
  isEditing,
  handleUpdateExam,
  upLoadImageExam,
  answer,
  setAnswer,
}) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 py-8">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white/80 backdrop-blur-sm shadow-2xl rounded-3xl border border-white/20 overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-8 text-white">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-2xl mb-4 backdrop-blur-sm">
                <svg
                  className="w-10 h-10"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
              </div>
              <h2 className="text-4xl font-bold mb-2">
                {isEditing ? "Cập nhật đề thi thử" : "Tạo đề thi thử"}
              </h2>
              <p className="text-blue-100 text-lg">
                {isEditing
                  ? "Chỉnh sửa thông tin đề thi"
                  : "Tạo đề thi mới với đầy đủ thông tin"}
              </p>
            </div>
          </div>

          {/* Form Content */}
          <div className="p-8 space-y-8">
            {/* Basic Information Section */}
            <div className="space-y-6">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">
                  Thông tin cơ bản
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700 flex items-center space-x-2">
                    <BadgeIcon className="w-4 h-4 text-blue-500" />
                    <span>Tên đề thi *</span>
                  </label>
                  <TextField
                    fullWidth
                    name="title"
                    value={formQuestionData.title}
                    onChange={handleChangeInputQuestion}
                    error={errors.title}
                    helperText={errors.title ? "Tên đề thi là bắt buộc" : ""}
                    placeholder="Nhập tên đề thi..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700 flex items-center space-x-2">
                    <LinkIcon className="w-4 h-4 text-blue-500" />
                    <span>URL đề thi</span>
                  </label>
                  <TextField
                    fullWidth
                    name="url"
                    value={formQuestionData?.url || ""}
                    onChange={handleChangeInputQuestion}
                    placeholder="Nhập URL của đề thi..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Số câu hỏi *
                  </label>
                  <TextField
                    fullWidth
                    type="number"
                    name="numberOfQuestions"
                    value={formQuestionData?.numberOfQuestions}
                    onChange={handleChangeInputQuestion}
                    placeholder="Nhập số câu hỏi..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Thời gian thi (phút) *
                  </label>
                  <TextField
                    fullWidth
                    type="number"
                    name="time"
                    value={formQuestionData?.time}
                    onChange={handleChangeInputQuestion}
                    placeholder="Nhập thời gian thi..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Kì thi *
                  </label>
                  <TextField
                    fullWidth
                    select
                    name="type"
                    value={formQuestionData?.type}
                    onChange={handleChangeInputQuestion}
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  >
                    {["TSA"].map((option, key) => (
                      <MenuItem
                        key={key}
                        value={option}
                        className="hover:bg-blue-50"
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Môn học *
                  </label>
                  <TextField
                    fullWidth
                    select
                    name="subject"
                    value={formQuestionData?.subject}
                    onChange={handleChangeInputQuestion}
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  >
                    {["TƯ DUY TOÁN HỌC"].map((option, key) => (
                      <MenuItem
                        key={key}
                        value={option}
                        className="hover:bg-blue-50"
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Truy cập *
                  </label>
                  <TextField
                    fullWidth
                    select
                    name="access"
                    value={formQuestionData?.access}
                    onChange={handleChangeInputQuestion}
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  >
                    {["Miễn phí", "Premium"].map((option, key) => (
                      <MenuItem
                        key={key}
                        value={option}
                        className="hover:bg-blue-50"
                      >
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Hiển thị đáp án
                  </label>
                  <div className="bg-white rounded-xl border border-gray-300 p-4 flex items-center justify-between">
                    <span className="text-sm text-gray-700">
                      Cho phép học sinh xem đáp án sau khi làm bài
                    </span>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formQuestionData?.isAnswer || false}
                          onChange={(e) => {
                            const syntheticEvent = {
                              target: {
                                name: "isAnswer",
                                value: e.target.checked,
                              },
                            };
                            handleChangeInputQuestion(syntheticEvent);
                          }}
                          color="primary"
                        />
                      }
                      label=""
                    />
                  </div>
                </div>

                {/* <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Link đáp án
                  </label>
                  <TextField
                    fullWidth
                    name="link_answer"
                    value={formQuestionData?.link_answer}
                    onChange={handleChangeInputQuestion}
                    placeholder="Link đáp án (nếu có)..."
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  />
                </div> */}
              </div>
            </div>

            {/* Image Upload Section */}
            {/* <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Ảnh đề thi</h3>
              </div>

              <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-6 border-2 border-dashed border-green-200 hover:border-green-400 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                      <svg
                        className="w-6 h-6 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-700">
                        {formQuestionData?.imgUrl
                          ? "✅ Đã có ảnh"
                          : "📎 Chưa chọn ảnh"}
                      </p>
                      <p className="text-xs text-gray-500">
                        Chọn ảnh đại diện cho đề thi
                      </p>
                    </div>
                  </div>
                  <Button
                    variant="contained"
                    onClick={() => refs.imageRefExam.current?.click()}
                    className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-semibold rounded-xl px-6 py-3 shadow-lg transform hover:scale-105 transition-all duration-200"
                    style={{ textTransform: "none" }}
                  >
                    📁 Chọn ảnh
                  </Button>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  ref={refs.imageRefExam}
                  onChange={upLoadImageExam}
                  className="hidden"
                />
              </div>
            </div> */}

            {/* Questions Section */}
            <div className="space-y-6">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-600 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">
                  Quản lý câu hỏi
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Chọn câu hỏi
                  </label>
                  <TextField
                    fullWidth
                    select
                    name="question"
                    value={question?.question}
                    onChange={handleChangeSelectQuestions}
                    variant="outlined"
                    size="medium"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        backgroundColor: "white",
                        "&:hover fieldset": {
                          borderColor: "#3b82f6",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#3b82f6",
                        },
                      },
                    }}
                  >
                    {listKeys.length > 0
                      ? listKeys.map((option, key) => (
                          <MenuItem
                            key={key}
                            value={option}
                            className="hover:bg-blue-50"
                          >
                            {option}
                          </MenuItem>
                        ))
                      : Array.from(
                          { length: 50 },
                          (v, i) => `Câu ${i + 1}`
                        ).map((option, key) => (
                          <MenuItem
                            key={key}
                            value={option}
                            className="hover:bg-blue-50"
                          >
                            {option}
                          </MenuItem>
                        ))}
                  </TextField>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-semibold text-gray-700">
                    Upload file đề thi
                  </label>
                  <Button
                    component="label"
                    variant="contained"
                    fullWidth
                    className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-semibold rounded-xl py-3 shadow-lg transform hover:scale-105 transition-all duration-200"
                    style={{ textTransform: "none" }}
                    startIcon={<CloudUploadIcon />}
                  >
                    📄 Nhập đề thi từ file docx
                    <VisuallyHiddenInput
                      type="file"
                      ref={refs.inputRefQuestion}
                      onChange={handleChangeUploadFileQuestions}
                    />
                  </Button>
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-sm font-semibold text-gray-700">
                  Nội dung câu hỏi
                </label>
                <TextField
                  fullWidth
                  multiline
                  rows={8}
                  name="contentQuestions"
                  value={question?.contentQuestions}
                  onChange={handleChangeContentQuestions}
                  placeholder="Nhập nội dung câu hỏi..."
                  variant="outlined"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      backgroundColor: "white",
                      "&:hover fieldset": {
                        borderColor: "#3b82f6",
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#3b82f6",
                      },
                    },
                  }}
                />
                {question?.contentQuestions && (
                  <div className="mt-3 p-4 bg-green-50 rounded-lg border border-green-200">
                    <div className="flex items-center space-x-2 mb-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span className="text-sm font-medium text-green-700">
                        Preview Lời giải
                      </span>
                    </div>
                    <MathRendererContent content={question?.contentQuestions} />
                  </div>
                )}
              </div>

              {/* Explanation Section */}
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-green-500 to-teal-600 rounded-lg flex items-center justify-center">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">
                    Lời giải cho {question?.question || "câu hỏi"}
                  </h3>
                </div>

                {question?.question && (
                  <div className="bg-white/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-200">
                    <div className="space-y-2">
                      <label className="text-sm font-semibold text-gray-700">
                        Lời giải chi tiết
                      </label>
                      <TextField
                        fullWidth
                        multiline
                        rows={6}
                        name="explanation"
                        value={question?.explanation || ""}
                        onChange={handleChangeContentQuestions}
                        placeholder="Nhập lời giải chi tiết cho câu hỏi này..."
                        variant="outlined"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            backgroundColor: "white",
                            "&:hover fieldset": {
                              borderColor: "#10b981",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#10b981",
                            },
                          },
                        }}
                      />
                      <div className="text-xs text-gray-500 mt-1">
                        💡 Hỗ trợ HTML tags và MathJax để hiển thị công thức
                        toán học
                      </div>

                      {question?.explanation && (
                        <div className="mt-3 p-4 bg-green-50 rounded-lg border border-green-200">
                          <div className="flex items-center space-x-2 mb-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                            <span className="text-sm font-medium text-green-700">
                              Preview Lời giải
                            </span>
                          </div>
                          <MathRendererContent
                            content={question?.explanation}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {!question?.question && (
                  <div className="text-center py-8 bg-gray-50 rounded-2xl">
                    <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg
                        className="w-8 h-8 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">
                      Chưa chọn câu hỏi
                    </h3>
                    <p className="text-gray-500">
                      Vui lòng chọn câu hỏi để nhập lời giải
                    </p>
                  </div>
                )}
              </div>

              {/* Answer Section */}
              <div className="space-y-6">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-yellow-500 to-orange-600 rounded-lg flex items-center justify-center">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">
                    Đáp án cho {question?.question || "câu hỏi"}
                  </h3>
                </div>

                {question?.question && (
                  <div className="bg-white/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-200">
                    <AnswerQuestion
                      question={question}
                      errors={errors}
                      handleChangeInputAnswer={handleChangeInputAnswer}
                      answer={answer}
                      setAnswer={setAnswer}
                    />
                  </div>
                )}

                {!question?.question && (
                  <div className="text-center py-8 bg-gray-50 rounded-2xl">
                    <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg
                        className="w-8 h-8 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-700 mb-2">
                      Chưa chọn câu hỏi
                    </h3>
                    <p className="text-gray-500">
                      Vui lòng chọn câu hỏi để nhập đáp án
                    </p>
                  </div>
                )}
              </div>

              {/* Question Image Upload */}
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6 border border-blue-200">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-blue-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-gray-700">
                        {question?.imageUrl
                          ? `✅ Đã có ảnh cho ${question?.question}`
                          : `📤 Tải ảnh cho ${question?.question} (nếu có)`}
                      </p>
                    </div>
                  </div>
                  <Button
                    variant="outlined"
                    onClick={() => refs.imageRefQuestion.current?.click()}
                    className="border-2 border-dashed border-blue-300 hover:border-blue-400 text-blue-700 hover:bg-blue-50 rounded-xl px-6 py-2 transition-all"
                    style={{ textTransform: "none" }}
                  >
                    {question?.imageUrl ? "🔄 Thay đổi ảnh" : "📁 Chọn ảnh"}
                  </Button>
                </div>
                <input
                  type="file"
                  accept="image/*"
                  ref={refs.imageRefQuestion}
                  onChange={upLoadImageQuestions}
                  className="hidden"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex flex-wrap gap-4 justify-center">
                <Button
                  variant="contained"
                  onClick={() => setOpenDialogQuestion(true)}
                  className="bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-semibold rounded-xl px-8 py-3 shadow-lg transform hover:scale-105 transition-all duration-200"
                  style={{ textTransform: "none" }}
                  startIcon={<UploadFileIcon />}
                >
                  👁️ Xem câu hỏi
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    localStorage.setItem(
                      "examData",
                      JSON.stringify(formQuestionData)
                    );
                    localStorage.setItem("answers", JSON.stringify(answer));
                    window.open(`/view-exam`, "_blank");
                  }}
                  className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white font-semibold rounded-xl px-8 py-3 shadow-lg transform hover:scale-105 transition-all duration-200"
                  style={{ textTransform: "none" }}
                  startIcon={<UploadFileIcon />}
                >
                  📄 Xem đề thi
                </Button>
              </div>
            </div>

            {/* Time Settings Section */}
            <div className="space-y-6">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gradient-to-r from-orange-500 to-red-600 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">
                  Cài đặt thời gian
                </h3>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateTimePicker"]}>
                    <DateTimePicker
                      label="Thời gian bắt đầu"
                      viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                      }}
                      value={formQuestionData.startTime}
                      onChange={handleChangeDateStartTime}
                      ampm={false}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#3b82f6",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                          },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateTimePicker"]}>
                    <DateTimePicker
                      label="Thời gian kết thúc"
                      viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                      }}
                      value={formQuestionData.endTime}
                      onChange={handleChangeDateEndTime}
                      ampm={false}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          backgroundColor: "white",
                          "&:hover fieldset": {
                            borderColor: "#3b82f6",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                          },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </div>
            </div>

            {/* Answer Summary */}
            {answer && Object.keys(answer).length > 0 && (
              <div className="space-y-6">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
                    <svg
                      className="w-5 h-5 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 4h6m-6 4h6m-6 4h6"
                      />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">
                    Tóm tắt đáp án
                  </h3>
                </div>

                <div className="bg-gradient-to-r from-indigo-50 to-purple-50 rounded-2xl p-6 border border-indigo-200">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-96 overflow-y-auto">
                    {Object.entries(answer).map(
                      ([questionKey, answerValue]) => (
                        <div
                          key={questionKey}
                          className="bg-white rounded-lg p-3 border border-gray-200"
                        >
                          <div className="font-semibold text-sm text-gray-700 mb-1">
                            {questionKey}
                          </div>
                          <div className="text-xs text-gray-600">
                            {typeof answerValue === "string" ? (
                              <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded">
                                {answerValue}
                              </span>
                            ) : Array.isArray(answerValue) ? (
                              <span className="bg-green-100 text-green-800 px-2 py-1 rounded">
                                [{answerValue.join(", ")}]
                              </span>
                            ) : (
                              <div className="space-y-1">
                                {Object.entries(answerValue).map(
                                  ([key, value]) => (
                                    <div
                                      key={key}
                                      className="flex items-center space-x-1"
                                    >
                                      <span className="text-gray-500">
                                        {key}:
                                      </span>
                                      <span className="bg-purple-100 text-purple-800 px-1 py-0.5 rounded text-xs">
                                        {Array.isArray(value)
                                          ? `[${value.join(", ")}]`
                                          : value}
                                      </span>
                                    </div>
                                  )
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )
                    )}
                  </div>
                  <div className="mt-4 text-center">
                    <p className="text-sm text-gray-600">
                      Đã nhập đáp án cho{" "}
                      <span className="font-semibold">
                        {Object.keys(answer).length}
                      </span>{" "}
                      câu hỏi
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Final Actions */}
            <div className="space-y-6">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-gradient-to-r from-yellow-500 to-orange-600 rounded-lg flex items-center justify-center">
                  <svg
                    className="w-5 h-5 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-gray-800">Hoàn tất</h3>
              </div>

              <div className="flex flex-wrap gap-4 justify-center">
                {/* <Tooltip
                  title="Upload file đáp án của đề ở đây"
                  placement="top"
                >
                  <Button
                    variant="contained"
                    component="label"
                    className="bg-gradient-to-r from-yellow-500 to-orange-600 hover:from-yellow-600 hover:to-orange-700 text-white font-semibold rounded-xl px-8 py-3 shadow-lg transform hover:scale-105 transition-all duration-200"
                    style={{ textTransform: "none" }}
                    startIcon={<UploadFileIcon />}
                  >
                    📋 Upload Đáp án
                    <input
                      ref={refs.inputRef}
                      type="file"
                      accept=".json"
                      hidden
                      onChange={handleFileUpload}
                    />
                  </Button>
                </Tooltip> */}

                {isEditing ? (
                  <Button
                    variant="contained"
                    onClick={handleUpdateExam}
                    className="bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-semibold rounded-xl px-8 py-3 shadow-lg transform hover:scale-105 transition-all duration-200"
                    style={{ textTransform: "none" }}
                    startIcon={<CloudUploadIcon />}
                  >
                    🔄 Cập nhật đề thi
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={handleInsertExam}
                    className="bg-gradient-to-r from-green-500 to-blue-600 hover:from-green-600 hover:to-blue-700 text-white font-semibold rounded-xl px-8 py-3 shadow-lg transform hover:scale-105 transition-all duration-200"
                    style={{ textTransform: "none" }}
                    startIcon={<CloudUploadIcon />}
                  >
                    ✨ Tạo đề thi
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dialogs */}
      {openDialogQuestion && (
        <ViewQuestion
          openDialog={openDialogQuestion}
          setOpenDialog={setOpenDialogQuestion}
          q={question}
        />
      )}

      {openDialogExam && (
        <ViewExam
          openDialog={openDialogExam}
          setOpenDialog={setOpenDialogExam}
          questionsData={questionsData}
        />
      )}
    </div>
  );
}
